import styles from "./index.module.css";
import TextInput from "shared/@forms/TextInput";
import TextArea from "shared/@forms/TextArea";
import Select from "shared/@forms/Select";
import Button from "shared/Button";

import { useRefund, actionTypes } from "./useRefund";

export default function ({ iboNumber, transaction }) {
  const {
    submit,
    isWaiting,
    actionType,
    setActionType,
    reason,
    setReason,
    amount,
    setAmount,
  } = useRefund({
    iboNumber,
    transaction,
  });

  return (
    <form
      className={styles.container}
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <div className={styles.formGroup}>
        <h4 className={styles.formLabel}>Refund Type</h4>
        <Select
          value={actionType}
          disabled={isWaiting}
          onChange={(e) => {
            setActionType(e.target.value);
          }}
        >
          <option value={actionTypes.card}>Web Auth (Card)</option>
          <option value={actionTypes.ach}>ACH</option>
        </Select>
      </div>

      <div className={styles.formGroup}>
        <h4 className={styles.formLabel}>Reason</h4>
        <TextArea
          value={reason}
          disabled={isWaiting}
          required={true}
          onChange={(e) => {
            setReason(e.target.value);
          }}
        />
      </div>

      <div className={styles.formGroup}>
        <h4 className={styles.formLabel}>Amount</h4>
        <TextInput
          value={amount}
          disabled={isWaiting}
          required={true}
          onChange={(e) => {
            setAmount(e.target.value);
          }}
        />
      </div>

      <Button className={styles.formButton} disabled={isWaiting}>
        Issue Refund
      </Button>
    </form>
  );
}
